export type BrazilianBank = {
  code: string
  name: string
}

export const brazilianBanks: readonly BrazilianBank[] = [
  { code: '001', name: 'Banco do Brasil' },
  { code: '033', name: 'Santander' },
  { code: '077', name: 'Banco Inter' },
  { code: '104', name: 'Caixa Econômica Federal' },
  { code: '212', name: 'Banco Original' },
  { code: '237', name: 'Bradesco' },
  { code: '260', name: 'Nubank' },
  { code: '290', name: 'PagBank' },
  { code: '323', name: 'Mercado Pago' },
  { code: '336', name: 'C6 Bank' },
  { code: '341', name: 'Itaú Unibanco' },
  { code: '380', name: 'PicPay' },
  { code: '422', name: 'Banco Safra' },
  { code: '748', name: 'Sicredi' },
  { code: '756', name: 'Sicoob' },
]
